import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { SkodaLink } from '../../buttons';
import { CircularProgress } from '../../circularProgress';
import { useDynamicPercentage, useExpiryDateText, useRemainingValueText } from '../hooks';
import { WarrantyBaseProps } from '../types';

const useStyles = makeStyles({ name: 'WarrantyLarge' })(theme => ({
	root: {
		display: 'flex',
		gap: 100,
		position: 'relative',
		alignItems: 'center',
		maxWidth: 1200,
		width: '100%'
	},
	progress: {
		marginRight: 25
	},
	panelTitle: {
		display: 'flex',
		flexDirection: 'column',
		gap: 3
	},
	title: {
		fontWeight: 700,
		fontSize: '21px',
		lineHeight: '26px',
		letterSpacing: '0.02em'
	},
	expiryDate: {
		fontSize: '16px',
		lineHeight: '24px',
		letterSpacing: '0.02em',
		whiteSpace: 'nowrap'
	},
	remainingPanel: {
		display: 'flex',
		flexDirection: 'column',
		fontSize: '18px',
		lineHeight: '24px',
		letterSpacing: '0.02em',
		fontWeight: 700,
		gap: 4
	},
	labelRemaining: {
		color: '#9E9FA0'
	},
	valueRemaining: {

	},
	linkConditions: {
		fontSize: '12px',
		lineHeight: '12px',
		textAlign: 'end',
		position: 'absolute',
		bottom: 0,
		right: 0
	},
	circularProgressLabel: {
		fontSize: '21px',
		lineHeight: '26px'
	}
}));

export const WarrantyLarge = (props: WarrantyBaseProps) => {
	const { translations, value, max, className, link } = props;
	const { classes, cx } = useStyles(null, { props });

	const dynamicValue = useDynamicPercentage(value, max);
	const remainingValueText = useRemainingValueText(props);
	const expiryDateText = useExpiryDateText(props);

	return (
		<div className={cx(classes.root, className)}>
			<CircularProgress
				className={classes.progress}
				value={dynamicValue}
				variant='determinate'
				size={107}
				thickness={11}
				classes={{ circularProgressLabel: classes.circularProgressLabel }} />
			<div className={classes.panelTitle}>
				{translations.title && <span className={classes.title}>{translations.title}</span>}
				{expiryDateText && <span className={classes.expiryDate}>{expiryDateText}</span>}
			</div>
			<div className={classes.remainingPanel}>
				<span className={classes.labelRemaining}>{translations.remainingLabel}</span>
				<span className={classes.valueRemaining}>{remainingValueText}</span>
			</div>
			{link && <SkodaLink href={link} target='_blank' className={classes.linkConditions}>{translations.linkConditions}</SkodaLink>}
		</div>
	);
};
